import {useParams} from 'react-router-dom';
import {Alert, Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useUsageEvent} from '../hooks/useUsageEvent.ts';

// FNP-536: read-only detail view of a single raw UsageEvent. No edit drawer / tools —
// the FNP-215 ingestion writer owns the lifecycle. Renders the identity, attribution,
// and the free-form attributes payload.
export const DetailPage = () => {
    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record: usageEvent,
        loading,
        isError,
        notFound,
    } = useUsageEvent(id);

    if (loading) {
        return <PlatformLoader message='Loading usage event...Please wait'/>;
    }

    // Never hang on the loader: once the query has settled, a missing record or an
    // error gets an explicit message rather than an indefinite spinner.
    if (isError || notFound || !usageEvent) {
        return (
            <Alert color='red' title='Usage event not found'>
                No usage event found for id <code>{id}</code>.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={usageEvent.eventId}
            pageNavigation={<EditPageNavigation component={usageEvent}/>}
        >
            <Stack gap='lg'>
                <Profile record={usageEvent}/>
            </Stack>
        </FormPageLayout>
    );
};
